import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'

const AddCity = () => {
  const setLoader = useSetAtom(globalLoaderAtom)
    useEffect(() => {
        setLoader(true)
    }, [])
    const authentication = sessionStorage.getItem('authentication')
    let baseUrl = ' https://bus.mavenconnect.tech'
    if (window.location.origin.includes('mavenconnect.tech')) {
        baseUrl = ' https://bus.mavenconnect.tech'
      } else if (window.location.origin.includes('mavenconnect.biz')) {
        baseUrl = 'https://bus.mavenconnect.biz'
      }
   return (<Box
    sx={{
        width: 'calc(100% + 30px)',
        marginLeft: '-16px',
        marginRight: '-16px',
        height: `calc(100vh - 200px)`,
        overflow: 'hidden',
    }}
>
    <iframe
        src={`${baseUrl}/addCity?authentication=${encodeURIComponent(authentication)}`}
        title="Add City"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        onLoad={() => { setLoader(false) }}
    />
</Box>
    )
}

export default AddCity
